import type { GroupDetail } from 'models';
import { Slider } from 'ui';
import { useGetGroupPreviewIcon, useGetGroupPreviewTypeNameInPlural } from '../../hooks';
import { type GroupScope, getGroupScopeFromPreviewType } from '../../models';
import { PreviewCard, type PreviewEntityType } from './preview-card';

type P = {
  getPathToDetail: (id: string, options: { entityType: PreviewEntityType }) => string;
  group: GroupDetail;
  navigateToGroups: (id: string, scope: GroupScope) => Promise<void>;
};

const GroupPreview = ({ getPathToDetail, group, navigateToGroups }: P) => {
  const getGroupPreviewTypeNameInPlural = useGetGroupPreviewTypeNameInPlural();
  const getGroupPreviewIcon = useGetGroupPreviewIcon();

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
      {group.preview?.map((previewSection) => (
        <Slider
          colSpan={10}
          controls={{
            seeAll: {
              async onClick() {
                await navigateToGroups(group.id, getGroupScopeFromPreviewType({ groupType: previewSection.groupType }));
              },
              total: previewSection.total,
            },
            title: getGroupPreviewTypeNameInPlural({ groupType: previewSection.groupType }),
            titleIcon: getGroupPreviewIcon({ groupType: previewSection.groupType }),
            titleLevel: 4,
          }}
          items={previewSection.data.map((groupItem) => ({
            children: (
              <PreviewCard data={groupItem} getPathToDetail={getPathToDetail} type={previewSection.groupType} />
            ),
            key: `group-${groupItem.id}`,
          }))}
          key={previewSection.groupType}
          queryData={{
            fetchNextPage() {
              // Do nothing
            },
            hasNextPage: false,
            isFetching: false,
            isLoading: false,
          }}
        />
      ))}
    </>
  );
};

export default GroupPreview;
